import React, { useMemo } from "react";
import { ColDef } from "ag-grid-community";
import locale, { dateFormat } from "@bonliva-crm/locale";
import { AccommodationRequestTableColumns } from "@bonliva-crm/shared";
import moment from "moment";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import { Typography } from "@material-ui/core";

export function useInitialColumnDefs(): Array<ColDef<any>> {
  const defs = useMemo(() => {
    const result: Array<ColDef> = [];

    result.push({
      field: AccommodationRequestTableColumns.City,
      headerName: locale.accommodationRequestTableColumnType.City,
      valueGetter: (params) => {
        return params.data?.city ?? "";
      },
      wrapText: true,
      sortable: false
    });

    result.push({
      field: AccommodationRequestTableColumns.ArrivalDate,
      headerName: locale.accommodationRequestTableColumnType.ArrivalDate,
      valueGetter: (params) => {
        return params.data?.firstArrival
          ? moment(params.data?.firstArrival).format(dateFormat)
          : "";
      },
      wrapText: true,
      sortable: false
    });

    result.push({
      field: AccommodationRequestTableColumns.Sender,
      headerName: locale.accommodationRequestTableColumnType.Sender,
      valueGetter: (params) => {
        return params.data?.createdBy?.Name ?? "";
      },
      wrapText: true,
      sortable: false
    });

    result.push({
      field: AccommodationRequestTableColumns.Consultant,
      headerName: locale.accommodationRequestTableColumnType.Consultant,
      wrapText: true,
      sortable: false,
      valueGetter: (params) => {
        return params.data?.consultantName ?? "";
      }
    });

    result.push({
      field: AccommodationRequestTableColumns.Week,
      headerName: locale.accommodationRequestTableColumnType.Week,
      wrapText: true,
      sortable: false,
      cellRenderer: (props) => {
        if (!props.data?.weeks?.length) {
          return "";
        }

        return (
          <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
            {props.data?.weeks?.map((x, i) => (
              <Typography
                key={i}
                color={"primary"}
                style={{
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center"
                }}
                onClick={(e) => {
                  e.preventDefault();
                  window.open(x.link, "_blank");
                }}
              >
                {x.name}
                <OpenInNewIcon color={"inherit"} fontSize={"small"} />{" "}
              </Typography>
            ))}
          </div>
        );
      }
    });

    result.push({
      field: AccommodationRequestTableColumns.Status,
      headerName: locale.accommodationRequestTableColumnType.Status,
      wrapText: true,
      sortable: false,
      valueGetter: (params) => {
        return params.data?.status?.status
          ? locale.accommodationRequestStatusType[params.data.status.status]
          : "";
      }
    });

    result.push({
      field: AccommodationRequestTableColumns.CreatedOn,
      headerName: locale.accommodationRequestTableColumnType.CreatedOn,
      valueGetter: (params) => {
        return params.data?.createdOn
          ? `${moment(params.data?.createdOn).format(dateFormat)}`
          : "";
      },
      wrapText: true,
      sortable: false
    });

    return result;
  }, []);

  return defs;
}
